import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MemberType, UserType } from 'api/models';
import { getMembers } from 'data/members/actions';
import { MembersState, selectMembers } from 'data/members/slice';

/**
 *
 * @deprecated Use `UsersStore` and `TeamsStore` to read users and teams.
 * Account permission information by user should come from a different store.
 */
export const useStoreMembers = (): MembersState => {
  const membersStoreData = useSelector(selectMembers);
  const done = membersStoreData.loadedAllMembers;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!done) {
      dispatch(getMembers());
    }
  }, [dispatch, done]);

  return membersStoreData;
};

/**
 * @deprecated Use `UsersStore.ofMemberType`
 */
export const useNativeMembers = (): MembersState => {
  const membersStoreData = useStoreMembers();
  const [nativeMembers, setNativeMembers] = useState<MembersState>({
    teams: [],
    users: [],
    members: [],
    loading: membersStoreData.loading,
    loadedAllMembers: membersStoreData.loadedAllMembers,
  });

  useEffect(() => {
    const nativeUsers = (membersStoreData.users ?? []).filter(
      (user) => user.userType === UserType.Native,
    );

    setNativeMembers({
      loading: membersStoreData.loading,
      loadedAllMembers: membersStoreData.loadedAllMembers,
      teams: (membersStoreData.teams ?? []).filter(
        (team) => team.teamType === MemberType.Native,
      ),
      users: nativeUsers,
      members: membersStoreData.members.filter(
        ({ user }) => user.userType === UserType.Native,
      ),
    });
  }, [
    membersStoreData.teams,
    membersStoreData.users,
    membersStoreData.members,
    membersStoreData.loading,
    membersStoreData.loadedAllMembers,
  ]);

  return nativeMembers;
};
